import Vuex from 'vuex'

import core from './modules/core'
import dialog from './modules/dialog'
import form from './modules/form'
import snackbar from './modules/snackbar'
import signature from './modules/signature'
import list from './modules/list'
import report from './modules/report'
import tab from './modules/tab'
import settings from './modules/settings'
import auth from './modules/auth'
import filterTableHeader from './modules/filterTableHeader'

const vuex = new Vuex.Store({
  modules: {
    core,
    dialog,
    form,
    snackbar,
    signature,
    list,
    report,
    tab,
    settings,
    auth,
    filterTableHeader
  }
})

export default vuex
